'use client';

import { useCommerceQueryClient } from '@lib/commerce/useCommerceQueryClient';
import { QueryClientProvider } from '@tanstack/react-query';
import { PropsWithChildren } from 'react';

type CommerceQueryProviderProps = PropsWithChildren<{
  /** MULTI_CART: cache commerce-core's org and user context with the header's. */
  shareReferenceQueries?: boolean;
}>;

export const CommerceQueryProvider = ({
  shareReferenceQueries = false,
  children,
}: CommerceQueryProviderProps) => {
  const queryClient = useCommerceQueryClient(shareReferenceQueries);

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
